import { IImageProps, Image as BaseImage } from 'native-base';
import { forwardRef } from 'react';

export type ImageProps = IImageProps;

export const Image = forwardRef(({ ...props }: ImageProps, ref): JSX.Element => {
  return <BaseImage role="img" {...props} ref={ref} />;
});
